/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Activity_Period_WeekInputs */

const en_analytics_activity_period_week = /** @type {(inputs: Analytics_Activity_Period_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week`)
};

const de_analytics_activity_period_week = /** @type {(inputs: Analytics_Activity_Period_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woche`)
};

const fr_analytics_activity_period_week = /** @type {(inputs: Analytics_Activity_Period_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine`)
};

const es_analytics_activity_period_week = /** @type {(inputs: Analytics_Activity_Period_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana`)
};

const it_analytics_activity_period_week = /** @type {(inputs: Analytics_Activity_Period_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settimana`)
};

const nl_analytics_activity_period_week = /** @type {(inputs: Analytics_Activity_Period_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week`)
};

const pl_analytics_activity_period_week = /** @type {(inputs: Analytics_Activity_Period_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tydzień`)
};

const fi_analytics_activity_period_week = /** @type {(inputs: Analytics_Activity_Period_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viikko`)
};

const da_analytics_activity_period_week = /** @type {(inputs: Analytics_Activity_Period_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uge`)
};

const sv_analytics_activity_period_week = /** @type {(inputs: Analytics_Activity_Period_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vecka`)
};

/**
* | output |
* | --- |
* | "Week" |
*
* @param {Analytics_Activity_Period_WeekInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_activity_period_week = /** @type {((inputs?: Analytics_Activity_Period_WeekInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Activity_Period_WeekInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_activity_period_week(inputs)
	if (locale === "fr") return fr_analytics_activity_period_week(inputs)
	if (locale === "es") return es_analytics_activity_period_week(inputs)
	if (locale === "it") return it_analytics_activity_period_week(inputs)
	if (locale === "nl") return nl_analytics_activity_period_week(inputs)
	if (locale === "pl") return pl_analytics_activity_period_week(inputs)
	if (locale === "fi") return fi_analytics_activity_period_week(inputs)
	if (locale === "da") return da_analytics_activity_period_week(inputs)
	if (locale === "sv") return sv_analytics_activity_period_week(inputs)
	return en_analytics_activity_period_week(inputs)
});